import {
  Component,
  Input,
  Output,
  EventEmitter,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';

import { NavigationExtras, Router, RouterModule } from '@angular/router';

import '@esi/leaf-web/lib/wc/components/button/button';

import type { LeafButton } from '@esi/leaf-web/lib/wc';

@Component({
  selector: 'cigna-leaf-button',
  standalone: true,
  imports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-button
      [variant]="variant"
      [size]="size"
      [disabled]="disabled"
      [loading]="loading"
      [text]="text"
      [hideText]="hideText"
      [neutral]="neutral"
      [href]="href"
      [type]="type"
      [target]="target"
      [svg]="svg"
      [iconPosition]="iconPosition"
      [iconRotateDegree]="iconRotateDegree"
      [iconFlipDirection]="iconFlipDirection"
      [fullWidth]="fullWidth"
      [buttonAriaExpanded]="buttonAriaExpanded"
      [loadingComplete]="loadingComplete"
      [ariaLive]="ariaLive"
      [splitButtonType]="splitButtonType"
      (click)="handleClick($event)"
    >
    </leaf-button>
  `,
})
export class CignaLeafButtonComponent {
  @Input() variant: LeafButton['variant'];
  @Input() size: LeafButton['size'];
  @Input() disabled: LeafButton['disabled'];
  @Input() loading: LeafButton['loading'];
  @Input() text: LeafButton['text'];
  @Input() hideText: LeafButton['hideText'];
  @Input() neutral: LeafButton['neutral'];
  @Input() fullWidth: LeafButton['fullWidth'];
  @Input() href: LeafButton['href'];
  @Input() target: LeafButton['target'];
  @Input() type: LeafButton['type'];
  @Input() svg: LeafButton['svg'];
  @Input() iconPosition: LeafButton['iconPosition'];
  @Input() iconRotateDegree: LeafButton['iconRotateDegree'];
  @Input() iconFlipDirection: LeafButton['iconFlipDirection'];
  @Input() loadingComplete: LeafButton['loadingComplete'];
  @Input() ariaLive: LeafButton['ariaLive'];
  @Input() splitButtonType: LeafButton['splitButtonType'];
  @Input() buttonAriaExpanded: LeafButton['buttonAriaExpanded'];

  /**
   * ********
   * CUSTOM ANGULAR PROPERTIES
   */
  @Input() routerLink?: boolean;
  @Input() navigationExtras?: NavigationExtras;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClick = new EventEmitter<MouseEvent>();

  constructor(private router: Router) {}

  handleClick(event: MouseEvent) {
    if (this.routerLink && this.href) {
      event.preventDefault();
      event.stopPropagation();
      this.router.navigateByUrl(this.href, this.navigationExtras);
    } else {
      this.onClick.emit(event);
    }
  }
}
